import ComponentModule from 'lib/component-module';
import tippy from 'tippy.js';
import store from '../store';

ComponentModule.AddModule('.locations-map', {
    prefix: 'locations-map-',
    components: [
        {
            name: 'template',
            data(){
                return {
                    region: 0,
                    resizeTimeout: null,
                    openedId: null,
                    locations: [],
                    regions: window.locationsMapData.regions,
                    data: window.locationsMapData.locations,
                    fullscreenTooltipContainer: null,
                    store: store
                };
            },
            computed: {
                isMobile: function() {
                    return store.state.isMobile;
                }
            },
            watch: {
                locations() {
                    const elms = this.$el.getElementsByClassName('locations-map__location-pin');
                    for (var i = 0; i < elms.length; i++) {
                        const e = elms[i];
                        const l = this.locations[i];

                    }
                },
                region(){
                    this.moveToRegion();
                    this.calculatePosition();
                },
                openedId(){
                    if(this.openedId === null){
                        this.setContentTooltipReference(null);
                    }
                },
                isMobile: function() {
                    if (this.isMobile) {
                        let map = this.$el.parentNode;
                        map.style.removeProperty('height');
                    }
                }
            },
            mounted() {
                this.calculatePosition();
                window.addEventListener("resize", this.resize);
            },
            destroyed() {
                window.removeEventListener("resize", this.resize);
            },
            methods: {
                setContentTooltipReference(content) {
                    const body = document.querySelector('body');
                    if (this.openedId === null && this.fullscreenTooltipContainer){
                        body.removeChild(this.fullscreenTooltipContainer);
                        this.fullscreenTooltipContainer = null;
                    }

                    if (content === null){
                        return null;
                    }

                    const div = this.fullscreenTooltipContainer || document.createElement('div');
                    body.appendChild(div);
                    div.classList.add('locations-map__tooltip-fullscreen');
                    div.appendChild(content);

                    this.fullscreenTooltipContainer = div;
                },
                getPrefixCss() {
                    var styles = window.getComputedStyle(document.documentElement, ''),
                    pre = (Array.prototype.slice
                            .call(styles)
                            .join('')
                            .match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o'])
                          )[1],
                    dom = ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1];
                    return {
                        dom: dom,
                        lowercase: pre,
                        css: '-' + pre + '-',
                        js: pre[0].toUpperCase() + pre.substr(1)
                    };
                },
                setStyleWithPrefix(el, style, value){
                    const { css } = this.getPrefixCss();
                    el.style[css+style] = value;
                },
                calculateDiff(){

                    if(!this.isMobile) {
                        this.calculateHeight();
                    } 

                    let realWidth = 0;
                    let realHeight = 0;

                    const fullWidth = 1610;
                    const fullHeight = 770;
                    const fullRatio = fullWidth/fullHeight;
                    const containerWidth = this.$el.parentElement.offsetWidth;
                    const containerHeight = this.$el.parentElement.offsetHeight;
                    const containerRation = containerWidth/containerHeight;


                    if(containerRation > fullRatio){
                        realWidth = containerWidth;
                        realHeight = containerWidth/fullRatio;
                    } else {
                        realWidth = containerHeight*fullRatio;
                        realHeight = containerHeight;
                    }

                    return {
                        w: realWidth,
                        h: realHeight,
                        x: realWidth/fullWidth,
                        y: realHeight/fullHeight
                    };
                },
                moveToRegion(){
                    let l = 0;
                    let t = 0;

                    if (this.region !== null && window.innerWidth < 835){
                        const { x:xDiff, y:yDiff, w } = this.calculateDiff();
                        const region = this.regions[this.region];
                        l = region.coordinates[0] * xDiff * -1;
                        t = region.coordinates[1] * yDiff * -1;

                        const offsetWidth = this.$el.parentElement.offsetWidth;
                        const offsetHeight = this.$el.parentElement.offsetHeight;

                        const minLeft = (w - offsetWidth) * -1;
                        const minTop = (w - offsetHeight) * -1;

                        if (l < minLeft) {
                            l = minLeft;
                        }

                        if (t < minTop) {
                            t = minTop;
                        }
                    }

                    this.$el.parentElement.style['background-position'] = `${l}px ${t}px`;
                    this.$refs.locationsContainer.style.left = `${l}px`;
                    this.$refs.locationsContainer.style.top = `${t}px`;
                },
                open(id){
                    this.openedId = id;
                },
                resize(){
                    const context = this;

                    if (this.resizeTimeout) {
                        clearTimeout(this.resizeTimeout);
                    }

                    this.resizeTimeout = setTimeout(function(){
                        context.resizeTimeout = null;
                        context.calculatePosition();
                    }, 500);

                    this.moveToRegion();
                },
                calculatePosition(){
                    const { x:xDiff, y:yDiff } = this.calculateDiff();

                    const locations = [];
                    this.data.forEach(i => {
                        const [l, t] = i.coordinates;
                        const _top = Math.round(t * yDiff);
                        const _left = Math.round(l * xDiff);

                        locations.push({
                            ...i,
                            coordinates: [`${_left}px`, `${_top}px`],
                        })
                    });

                    this.locations = locations;
                },
                calculateHeight() {
                    let fullWidth = 1610;
                    let fullHeight = 770;
                    let fullRatio = fullWidth/fullHeight;
                    let windowWidth = window.innerWidth;
                    let calcHeight = Math.round(windowWidth / fullRatio);
                    let map = this.$el.parentNode;
                    map.style.height = `${calcHeight}px`;
                }
            },
            components: {
                'content-tooltip': {
                    name: 'content-tooltip',
                    props: ['id', 'data', 'open', 'isOpen', 'setContentTooltipReference'],
                    data(){
                        return {
                            tippyInstance: null,
                            contentChild: null
                        }
                    },
                    computed: {
                        taggingMeta: function() {
                            return JSON.stringify({
                                "type": "layer",
                                "category": "Preview Card",
                                "action": "Open",
                                "label": this.data.name
                            })
                        }
                    },
                    watch: {
                        data(){
                            this.mobileMode();
                            this.tippyInstance.setContent('');
                        },
                        isOpen(){
                            this.mobileMode();
                            this.tippyInstance.setContent('');
                            if (this.isOpen) {
                                // increase z-index of currently open tooltip
                                let tippyTarget = document.querySelector(`#tippy-${this.id + 1}`);
                                tippyTarget.style.zIndex = 100;
                            }
                        }
                    },
                    methods: {
                        onOpen(){
                            this.open(this.id);
                        },
                        onClose(){
                            this.open(null);
                        },
                        mobileMode(){
                            if (this.isOpen && window.innerWidth < 650){
                                this.setContentTooltipReference(this.contentChild);
                            } else {
                                this.setTooltipContent();
                            }
                        },
                        setTooltipContent(){
                            this.tippyInstance.popper.querySelector('.tippy-content').appendChild(this.contentChild);
                        }
                    },
                    mounted() {
                        const context = this;
                        this.contentChild = this.$el.children[0];
                        const instance = tippy(this.$el, {
                            content: '',
                            maxWidth: 'none',
                            allowHTML: true,
                            interactive: true,
                            placement: this.data.placement,
                            trigger: 'manual',
                            zIndex: 99,
                            onCreate(instance) {
                                context.tippyInstance = instance;
                                context.setTooltipContent();
                                instance.show();
                            },
                            onHide(instance) {
                                return false;
                            }
                        });
                    }
                }
            }
        }
    ]
});
